import { subscriptionClient } from './../../graphql.module';
import { SlsService } from 'src/app/core/services/sls.service';
import { Apollo } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
  private apollo: Apollo,
  private sls: SlsService,
  private router: Router
  ) { }

  reset(){
    subscriptionClient.close(false,false);
    (<any>subscriptionClient).connect();
    return this.apollo.use('external').client.resetStore();
  }

  async logout() {
    console.log("Logout called");
    if (subscriptionClient) {
      subscriptionClient.close(false, false);
      subscriptionClient.unsubscribeAll();
      (<any>subscriptionClient).connect();
    }
    await this.apollo.use('external').client.clearStore();
    await this.apollo.use('external').client.resetStore(); // resetStore is a Promise
  
    // Wait for storage operations if they return Promises
    if (this.sls.remove instanceof Function) {
      await this.sls.remove('loginData');
    }
  
    if (this.sls.removeAllKeys instanceof Function) {
      await this.sls.removeAllKeys();
    }
  
    localStorage.clear();
  
    await this.waitForCompleteLogout(); // wait for logout process
    console.log("Logout called end");
    this.router.navigate(['/index']); // navigate only after everything completes
  }
  

  async waitForCompleteLogout(maxRetries = 5, delayMs = 1000): Promise<any> {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      const loginUserData = this.sls.get('loginData');
      if (loginUserData === '') {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
    throw new Error('Logout not completed');
  }
  logoutOnSignup(){
    if(subscriptionClient){
      subscriptionClient.close(false,false);
      (<any>subscriptionClient).connect();
    }
    this.apollo.use('external').client.resetStore();
    this.sls.remove('loginData');
  }

}
